import request from '../../../Helpers/Request';

class Combine {
    constructor(settings) {
        this.settings = settings;
    }

    values(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/feeds/${id}/combine`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    attributes(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/feeds/${id}/attributes`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    combined(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/feeds/${id}/combine/show`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/feeds/${id}/combine`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Combine;
